module.exports = __webpack_public_path__ + "static/media/daniela_coman.0ce28513.png";